<template>
  <a
    class="via-link via-row"
    :href="goUrl"
    target="_blank"
    @click="sendDlEvent({ retailerName: name })"
  >
    <div class="via-cell via-retailer">
      <img :src="logo" width="32" height="32" class="via-avatar" />
      <span class="via-retailer-name">
        <span>{{ name }}</span>
      </span>
    </div>
    <div class="via-cell via-price">
      <div v-if="showPrice === 'Yes'">{{ currencySymbol }} {{ price }}</div>
      <!-- <div v-else></div> -->
      <div class="via-stock-mobile" :class="stockClass">
        {{ inStock ? inStockText : outOfStockText }}
      </div>
    </div>
    <div class="via-cell via-stock">
      <span :class="stockClass">
        <span class="via-bull">&bull;</span>
        {{ inStock ? inStockText : outOfStockText }}
      </span>
    </div>
    <div class="via-cell via-cell-go"><div class="via-go">&#10140;</div></div>
  </a>
</template>

<script>
export default {
  name: 'ProductListItem',
  props: {
    name: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    showPrice: {
      type: String,
      default: '',
    },
    stock: {
      type: Number,
      default: 0,
    },
    logo: {
      type: String,
      default: '',
    },
    goUrl: {
      type: String,
      default: '',
    },
    inStockText: {
      type: String,
      default: '',
    },
    outOfStockText: {
      type: String,
      default: '',
    },
    currencySymbol: {
      type: String,
      default: '',
    },
  },
  computed: {
    inStock: ({ stock }) => stock !== 0,
    stockClass: ({ inStock }) => (inStock ? 'via-instock' : 'via-outofstock'),
  },
  methods: {
    dataLayerPush(eventName, keyVals) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: eventName,
        ...keyVals,
      })
    },
    sendDlEvent(keyVals) {
      const DL_EVENT_NAME = 'vendie_retailer_click'
      this.dataLayerPush(DL_EVENT_NAME, keyVals)
    },
  },
}
</script>

<style scoped>
.via-row {
  display: grid;
  grid-template-columns: 39% 18% 28% 15%;
  transition: 0.5s;
  border-top: 1px solid #cdcdcd;
  padding: 8px 0;
}

.via-link:hover {
  box-shadow: 0 3px 15px -2px rgb(0 0 0 / 12%);
}

.via-cell {
  text-align: center;
  padding: 0.5em 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}

.via-cell.via-retailer {
  justify-content: left;
  text-align: left;
}

.via-instock {
  color: #06d6a0;
}

.via-outofstock {
  color: #ffd166;
}

.via-go-outofstock {
  background-color: #cdcdcd !important;
  color: #a9a9a9;
  cursor: default;
}
.via-retailer-name {
  font-weight: 700;
  margin: 0 8px;
  padding-bottom: 1px;
  overflow-wrap: break-word;
  hyphens: auto;
}
.via-retailer-name span {
  border-bottom: 1px dashed;
}
.via-avatar {
  border-radius: 50%;
  box-shadow: 0px 2px 10px -1px rgb(85 85 85 / 8%),
    0px 1px 10px 0px rgb(85 85 85 / 6%), 0px 1px 30px 0px rgb(85 85 85 / 3%) !important;
}

.via-stock {
  font-weight: 700;
}
.via-bull {
  padding: 0 5px;
}

@media all and (max-width: 550px) {
  .via-cell.via-stock {
    display: none !important;
  }
  .via-row {
    grid-template-columns: 50% 30% 20%;
  }
  .via-price {
    display: flex;
    flex-direction: column;
  }
  .via-stock-mobile {
    display: block !important;
    font-weight: 700;
  }
}
@media all and (max-width: 380px) {
  .via-row {
    grid-template-columns: 55% 45%;
  }
  .via-cell.via-cell-go {
    display: none !important;
  }
}

.via-row:first-of-type {
  border: unset;
}

.via-stock-mobile {
  display: none;
}

/* ----------  Inside Table Styling ----------- */

.via-go {
  background-color: rgb(6, 214, 160);
  border-radius: 5px;
  /* border: 1px solid darkgray; */
  padding: 6px 16px;
  text-decoration: none;
  color: white;
  font-size: 19px;
}

/* Responsive adjustments */

@media all and (max-width: 550px) {
  .via-cell.via-stock {
    display: none !important;
  }

  .via-row {
    grid-template-columns: 50% 30% 20%;
  }

  .via-price {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .via-stock-mobile {
    display: block !important;
    font-weight: 700;
  }
}

@media all and (max-width: 380px) {
  .via-row {
    grid-template-columns: 55% 45%;
  }

  .via-cell.via-cell-go {
    display: none !important;
  }
}

/* WTB Button */

.vendie-wtb-button:hover {
  cursor: pointer;
}

/* End WTB Button */
</style>
